import React from 'react';

import workingGirl from './../../../static/img/working-girl.png'
import Divider from '../Divider/Divider';
import * as Scroll from 'react-scroll';

const About = () => {
    let ScrollLink = Scroll.Link;
    return (
        <div class="columns">
  <div class="column">
    
  <img src={workingGirl} alt="workingGirl"  />
  </div>
  <div class="column">
  <h1 class="title" style={{color:'#000000',textAlign:'center'}}>About </h1>
  <Divider/>
  <p>Experienced Full Time Freelancer, Handling Web / Mobile App development using various technologies like React, Node, React Native, JavaScripts, Java etc.. Passionate on deliver digital experiences ( both web and mobile ) with latest technologies. Always love to deliver projects which go beyond client's expectations.</p>
                  <div style={{alignItems:'center',marginTop:20,justifyContent:'center',alignContent:'center',alignSelf:'center',textAlign:'center'}}>
                  <a
                  href="https://drive.google.com/file/d/1AdUauAwdqZnImTRkysulTgsU_Css4FXn/view?usp=sharing"
                  target="_blank"
                >
                    <button class="btn" >  Download Profile  </button></a><br/>
                    
                 <ScrollLink
               to="skills"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
               >
                    <button class="btn" style={{backgroundColor:'#333',color:'#CCCCCC'}}>   Technical Skills </button>
                </ScrollLink>
                    </div>
  </div>
  </div>
      );
}
 
export default About;